"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceOrderFilterQuery = exports.ServiceOrderUpdate = exports.ServiceOrderCreate = exports.ServiceOrderCustomerTransport = exports.ServiceOrder = exports.CancellationDetails = exports.ServiceOrderInvoiceStatus = exports.ServiceOrderInvoiceStatuses = exports.ServiceFrequencyUnitLabels = exports.ServiceFrequencyUnit = exports.ServiceFrequencyUnits = exports.RentalPeriodUnitLabels = exports.RentalPeriodUnit = exports.RentalPeriodUnits = exports.ServiceOrderStatusLabels = exports.ServiceOrderStatus = exports.ServiceOrderStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const invoice_transport_1 = require("../invoice/invoice-transport");
const ServiceEvent_1 = require("./ServiceEvent");
const ServiceType_1 = require("./ServiceType");
const SubscriptionDetails_1 = require("./SubscriptionDetails");
const common_types_1 = require("./common-types");
Object.defineProperty(exports, "RentalPeriodUnit", { enumerable: true, get: function () { return common_types_1.RentalPeriodUnit; } });
Object.defineProperty(exports, "RentalPeriodUnitLabels", { enumerable: true, get: function () { return common_types_1.RentalPeriodUnitLabels; } });
Object.defineProperty(exports, "RentalPeriodUnits", { enumerable: true, get: function () { return common_types_1.RentalPeriodUnits; } });
Object.defineProperty(exports, "ServiceFrequencyUnit", { enumerable: true, get: function () { return common_types_1.ServiceFrequencyUnit; } });
Object.defineProperty(exports, "ServiceFrequencyUnitLabels", { enumerable: true, get: function () { return common_types_1.ServiceFrequencyUnitLabels; } });
Object.defineProperty(exports, "ServiceFrequencyUnits", { enumerable: true, get: function () { return common_types_1.ServiceFrequencyUnits; } });
Object.defineProperty(exports, "ServiceOrderStatus", { enumerable: true, get: function () { return common_types_1.ServiceOrderStatus; } });
Object.defineProperty(exports, "ServiceOrderStatusLabels", { enumerable: true, get: function () { return common_types_1.ServiceOrderStatusLabels; } });
Object.defineProperty(exports, "ServiceOrderStatuses", { enumerable: true, get: function () { return common_types_1.ServiceOrderStatuses; } });
exports.ServiceOrderInvoiceStatuses = invoice_transport_1.InvoiceStatuses;
exports.ServiceOrderInvoiceStatus = typebox_1.Type.Union(exports.ServiceOrderInvoiceStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.CancellationDetails = typebox_1.Type.Object({
    date: typebox_1.Type.String(),
    reason: typebox_1.Type.String(),
    customerFee: typebox_1.Type.Integer(),
    vendorFee: typebox_1.Type.Integer(),
});
exports.ServiceOrder = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    serviceGroupingID: typebox_1.Type.String({ format: 'uuid' }),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Customer
    status: common_types_1.ServiceOrderStatus,
    serviceType: ServiceType_1.ServiceTypeFull,
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    sequenceNumber: typebox_1.Type.Integer(),
    fullOrderNumber: typebox_1.Type.String(),
    startDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    endDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    removalDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    removalNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    events: typebox_1.Type.Array(ServiceEvent_1.ServiceEvent),
    subscriptionDetails: typebox_1.Type.Optional(SubscriptionDetails_1.SubscriptionDetails),
    serviceFrequency: typebox_1.Type.Integer(),
    serviceFrequencyUnit: common_types_1.ServiceFrequencyUnit,
    serviceDays: typebox_1.Type.Array(typebox_1.Type.Integer({ minimum: 1 })),
    serviceLocation: common_1.ServiceLocationTransport,
    internalNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()), // Denormalized from Hauler
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorOnlyNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    needsAttention: typebox_1.Type.Boolean(),
    originalRentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    adjustedRentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    rentalPeriodUnit: typebox_1.Type.Optional(common_types_1.RentalPeriodUnit),
    rentalExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    accountManagerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    cancellationDetails: typebox_1.Type.Optional(exports.CancellationDetails),
    // Issues
    // Payables
    invoiceStatus: typebox_1.Type.Record(typebox_1.Type.String({ format: 'uuid' }), exports.ServiceOrderInvoiceStatus),
    // TODO: pricingSnapshot - Type needs specs.
    metadata: common_1.MetaData,
});
exports.ServiceOrderCustomerTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.ServiceOrder, [
        'id',
        'serviceLocation',
        'serviceGroupingID',
        'customerName',
        'customerAccountNumber',
        'customerCompanyName',
        'status',
        'description',
        'sequenceNumber',
        'fullOrderNumber',
        'startDate',
        'endDate',
        'deliveryDate',
        'removalDate',
        'deliveryNotes',
        'removalNotes',
        'subscriptionDetails',
        'serviceFrequency',
        'serviceFrequencyUnit',
        'serviceDays',
        'serviceLocation',
        'customerID',
        'poNumber',
        'originalRentalPeriod',
        'adjustedRentalPeriod',
        'rentalPeriodUnit',
        'rentalExtensionFee',
        'invoiceStatus',
        'metadata',
    ]),
    typebox_1.Type.Object({
        serviceType: ServiceType_1.ServiceTypeCustomerTransport,
    }),
]);
exports.ServiceOrderCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceOrder, [
        'id',
        'serviceGroupingID',
        'serviceType',
        'events',
        'customerID',
        'subscriptionDetails',
        'metadata',
        'sequenceNumber',
        'fullOrderNumber',
        'invoiceStatus',
    ]),
    typebox_1.Type.Object({
        serviceTypeID: typebox_1.Type.String({ format: 'uuid' }),
        subscriptionDetails: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), SubscriptionDetails_1.SubscriptionDetailsUpsert])),
        serviceEvents: typebox_1.Type.Optional(typebox_1.Type.Array(ServiceEvent_1.ServiceEventCreate)),
    }),
]);
exports.ServiceOrderUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceOrder, [
        'id',
        'serviceGroupingID',
        'serviceType',
        'events',
        'customerID',
        'subscriptionDetails',
        'metadata',
        'sequenceNumber',
        'fullOrderNumber',
        'invoiceStatus',
    ]),
    typebox_1.Type.Object({
        serviceTypeID: typebox_1.Type.String({ format: 'uuid' }),
        subscriptionDetails: typebox_1.Type.Union([typebox_1.Type.String({ format: 'uuid' }), SubscriptionDetails_1.SubscriptionDetailsUpsert]),
    }),
]));
exports.ServiceOrderFilterQuery = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
        offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        orderBy: typebox_1.Type.Optional(typebox_1.Type.String()),
        reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        status: common_types_1.ServiceOrderStatus,
        statuses: typebox_1.Type.String(), // comma separated list of statuses
        startsAfter: typebox_1.Type.String({ format: 'date' }),
        startsBefore: typebox_1.Type.String({ format: 'date' }),
        endsAfter: typebox_1.Type.String({ format: 'date' }),
        endsBefore: typebox_1.Type.String({ format: 'date' }),
        deliveredAfter: typebox_1.Type.String({ format: 'date' }),
        deliveredBefore: typebox_1.Type.String({ format: 'date' }),
        removedAfter: typebox_1.Type.String({ format: 'date' }),
        removedBefore: typebox_1.Type.String({ format: 'date' }),
        vendorID: typebox_1.Type.String(), // comma separated list of vendorIDs
        needsAttention: typebox_1.Type.Boolean(),
        isSubscription: typebox_1.Type.Boolean(), // true if the serviceOrder has subscriptionDetails populated
        isCancelled: typebox_1.Type.Boolean(), // true if the serviceOrder has cancellationDetails populated
        accountManagerID: typebox_1.Type.String(),
    })),
]);
//# sourceMappingURL=ServiceOrder.js.map